<div class="container my-4">
  <div class="row">
    <div class="col-12">
      <span class="title_header_bar">
        <img style="position: absolute;left: 30px;top: 13px;" (click)="gotoSalesTargetSetup()"
          src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
        Sales Target For {{salesTargetUserName}}
      </span>
    </div>
  </div>
  <div class="card card_content">
    <div class="row d-flex justify-content-between align-items-center flex-wrap grid-margin">
      <div class="col-md-6">
        <button *ngIf="type !== 2" type="button" class="btn btn-primary text-nowrap" (click)="openPopup('')">
          <i class="fa fa-plus"></i> Add Service Provider Target
        </button>
      </div>
     
    </div>
    <form [formGroup]="form" *ngIf="type !== 2">
      <div class="row mb-3 d-flex justify-content-center">
        <div class="col-xl-5 mt-3">
          <mat-form-field appearance="fill" hideRequiredMarker>
            <mat-label>Service Provider</mat-label>
            <mat-select class="scrollbarcs" formControlName="serviceProviderId" placeholder="Select Service Provider">
              <mat-select-filter [displayMember]="'value'" [array]="serviceProviderList"
                (filteredReturn)="filterserviceProviderList = $event"></mat-select-filter>
              <mat-option *ngFor="let item of filterserviceProviderList" [value]="item.key"
                style="overflow-y: scroll !important;">
                {{item.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-xl-5 mt-3">
          <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
            <mat-label>Target Month</mat-label>
            <input readonly matInput  [matDatepicker]="monthFilter" id="monthFilter"
              formControlName="monthFilter" autocomplete="off" placeholder="Select Target Month"
              class="col-12 custom-input-border" specialIsAlphaNumeric (click)="FnmonthFilterPicker()"
              style="color:black;">
            <mat-datepicker-toggle matSuffix [for]="monthFilter" style="color:black;">
              <button mat-icon-button>
                <mat-icon>event</mat-icon>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">

                </svg>
              </button>
            </mat-datepicker-toggle>
            <mat-datepicker #monthFilter startView="multi-year" (monthSelected)="setMonthAndYear($event, monthFilter)"
              panelClass="example-month-picker">
            </mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
          <div class="col-md-6 d-flex justify-content-center">
            <button *ngIf="type !== 2" class="btn btn-primary mr-3" style="white-space:nowrap;"
              (click)="salestargetfilterSearchClick()">
              <i class="fa fa-search"></i> Search
            </button>
            <!-- <button type="button" class="btn btn-secondary" (click)="clearFilter()">
              <i class="fa fa-refresh"></i> Refresh
            </button> -->
            <app-button (refreshClicked)="clearFilter()"></app-button>

        </div>
      </div>
    </form>
    <div class="table-responsive mt-2 mb-4">
      <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
        <ng-container matColumnDef="providerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="providerName">Service Provider</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.providerName}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="targetDayCount">
          <mat-header-cell *matHeaderCellDef mat-sort-header="targetDayCount">Target Count Per Day</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.targetDayCount}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="targetMonthCount">
          <mat-header-cell *matHeaderCellDef mat-sort-header="targetMonthCount">Target Count Per Month</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.targetMonthCount}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="targetYearCount">
          <mat-header-cell *matHeaderCellDef mat-sort-header="targetYearCount">Target Count Per Year</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.targetYearCount}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="effectiveFrom">
          <mat-header-cell *matHeaderCellDef mat-sort-header="effectiveFrom">Target Month</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.effectiveFrom | date:'MMM/yyyy'}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <div class="text-truncate text-center">
              <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3"
                (click)="openPopup(dataField)"></i>

              <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-trash-can"
                (click)="deleteUser(dataField.id)"></i>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></mat-row>
      </mat-table>
    </div>
    <div *ngIf="data.length===0" class="text-center">
        No Results Found
      </div>
    <div class="table_pagenation">
      <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
        [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
